module.exports = __webpack_public_path__ + "static/media/REN.76ab290c.svg";